/* eslint-disable @typescript-eslint/camelcase */
import Joi from '@hapi/joi';

const username = Joi.string()
  .label('User name')
  // .regex(/^\w+\.\w+$/, 'required')
  .min(1)
  .max(250)
  .required();

const firstName = Joi.string()
  .label('First name')
  .alphanum()
  .min(1)
  .max(250)
  .required();

const lastName = Joi.string()
  .label('Last name')
  .alphanum()
  .min(1)
  .max(250)
  .required();

const email = Joi.string()
  .label('Email')
  .email({ minDomainSegments: 2, tlds: false })
  .required();

const cc_email = Joi
  .string()
  .label('CC Email')
  .when('send_cc_email', {
    is: 1,
    then: Joi.string().email({ minDomainSegments: 2, tlds: false }).required(),
    otherwise: Joi.allow(null, '').optional(),
  });

const send_email = Joi.number().required();
const send_sms = Joi.number().required();
const lock_battery_level_send_email = Joi.number().required();
const lock_battery_level_send_sms = Joi.number().required();
const lock_offline_send_email = Joi.number().required();
const lock_offline_send_sms = Joi.number().required();
const post_tour_send_email = Joi.number().required();
const post_tour_send_sms = Joi.number().required();
const send_cc_email = Joi.number().required();
const lock_jam_events_send_email = Joi.number().required();
const lock_jam_events_send_sms = Joi.number().required();
// const send_monthly_report = Joi.number().required();

const phone = Joi.string()
  .label('Phone')
  // .regex(/^\d{3}-\d{3}-\d{4}$/, 'required')
  .required();

const pass_word = Joi.string()
  .label('Password')
  .allow('');

const oldEmail = Joi.string().allow('');
const oldPhone = Joi.string().allow('');

export default Joi.object({
  username,
  firstName,
  lastName,
  phone,
  email,
  pass_word,
  send_email,
  send_sms,
  lock_battery_level_send_email,
  lock_battery_level_send_sms,
  lock_offline_send_email,
  lock_offline_send_sms,
  oldEmail,
  oldPhone,
  post_tour_send_email,
  post_tour_send_sms,
  send_cc_email,
  cc_email,
  lock_jam_events_send_email,
  lock_jam_events_send_sms,
  // send_monthly_report,
});
